
import { MessageSquare } from "lucide-react";
import { ReviewTable } from "./ReviewTable";
import { ReviewType } from "./types";

interface ReviewListProps {
  reviews: ReviewType[];
  selectedReviews: string[];
  onSelectReview: (reviewId: string, checked: boolean) => void;
  onToggleVisibility: (reviewId: string) => void;
  onToggleFeatured: (reviewId: string) => void;
  onDeleteRequest: (reviewId: string) => void;
}

export const ReviewList = ({
  reviews,
  selectedReviews,
  onSelectReview,
  onToggleVisibility,
  onToggleFeatured,
  onDeleteRequest
}: ReviewListProps) => {
  if (!reviews || reviews.length === 0) {
    return (
      <div className="text-center py-12 bg-muted/5 border rounded-xl">
        <MessageSquare className="h-12 w-12 mx-auto text-muted-foreground/30 mb-4" />
        <p className="text-muted-foreground">No reviews yet</p>
      </div>
    );
  }

  return (
    <div className="border rounded-lg">
      <ReviewTable
        reviews={reviews}
        selectedReviews={selectedReviews}
        onSelectReview={onSelectReview}
        onToggleVisibility={onToggleVisibility}
        onToggleFeatured={onToggleFeatured}
        onDeleteRequest={onDeleteRequest}
      />
    </div>
  );
};
